import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import '@/styles/iconfont.js'
import ElementUI from "element-ui";
import "@/styles/index.scss"; // global css
import "@/styles/element-varibles.scss";
import "@/permission"; // permission control
import HmContent from "@/components/HmContent";
import HmContainer from "@/components/HmContainer";
import commonVaribleMixin from "@/mixins/commonVaribleMixin";
// import Print from "vue-print-nb";
import Print from "@/utils/print";
import hmSvg from '@/components/hmSvg'
import { loadAreaData } from "@/utils/area";

import Treeselect from '@riophae/vue-treeselect'
import '@/styles/vue-treeselect.css'
Vue.component("treeselect", Treeselect);


Vue.mixin(commonVaribleMixin);
Vue.use(ElementUI);
Vue.component("hm-content", HmContent);
Vue.component("hm-container", HmContainer);
Vue.component('hm-svg', hmSvg)
Vue.use(Print);

import echarts from 'echarts'
import 'echarts/map/js/china'
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }
  next();
});

// 初始化加载省市区 CDN 数据（优先读缓存，不阻塞应用启动）
loadAreaData(store).catch(err => console.error("省市区数据初始化失败", err));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
